import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MaterialModule } from "@app/material.module";
import { UserAvatarModule } from "@app/shared/user-avatar/user-avatar.module";
import { TranslateModule } from "@ngx-translate/core";
import { AbsenceConflictDialogComponent } from "./absence-conflict-dialog.component";

@NgModule({
	declarations: [AbsenceConflictDialogComponent],
	imports: [CommonModule, MaterialModule, TranslateModule, UserAvatarModule],
	exports: [AbsenceConflictDialogComponent],
})
export class AbsenceConflictDialogModule {}
